import React, {} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {miteredSectionInterface} from "../../../../../../interfaces/sqftInterfaces";
import NavMiteredSegment from "./navMiteredSegment";

const NavMiteredSection = (props) => {
  const {sectionName, miteredSection, index} = props;

  let SEGMENTS = miteredSection.getSegments();

  return (
    <div className="mitered-section" data-id="${miteredSection.id}">
      <h3 className="content-header">
        {/*${TranslatesProvider.translate("sqft.navigation.mitered.title")}*/}
        {sectionName}
        <span className="text-inCircle">
               {('0' + (index + 1)).slice(-2)}
              </span>
      </h3>
      <div className="mitered-segments">
        {
          SEGMENTS.map((miteredSegment, index) => {
            return <NavMiteredSegment key={index}
                                   miteredSegment={miteredSegment}
                                   miteredSection={miteredSection}
                                   index={index} />
          })
        }
      </div>
    </div>
  )
};

NavMiteredSection.propTypes = {
  sectionName: PropTypes.object,
  miteredSection: PropTypes.shape(miteredSectionInterface)
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(NavMiteredSection);
